export const IconHouse = (props: JSX.IntrinsicElements['svg']) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.68194 11.8387L12.0132 4.34501L20.3444 11.8387C20.7551 12.2081 21.3873 12.1746 21.7567 11.764C22.126 11.3534 22.0926 10.7211 21.6819 10.3517L12.6819 2.25651C12.3017 1.9145 11.7247 1.9145 11.3444 2.25651L2.34444 10.3517C1.93383 10.7211 1.90036 11.3534 2.2697 11.764C2.63904 12.1746 3.27132 12.2081 3.68194 11.8387ZM17.7405 12C17.1882 12 16.7405 12.4477 16.7405 13V20H14.6496V15.5C14.6496 14.9477 14.2018 14.5 13.6496 14.5H10.3768C9.82454 14.5 9.37683 14.9477 9.37683 15.5V20H7.28592V13C7.28592 12.4477 6.8382 12 6.28592 12C5.73364 12 5.28592 12.4477 5.28592 13V21C5.28592 21.5523 5.73364 22 6.28592 22H10.3768C10.9291 22 11.3768 21.5523 11.3768 21V16.5H12.6496V21C12.6496 21.5523 13.0973 22 13.6496 22H17.7405C18.2927 22 18.7405 21.5523 18.7405 21V13C18.7405 12.4477 18.2927 12 17.7405 12Z"
      fill="#6A7B7D"
    />
  </svg>
);
